import Vue from 'vue';
import App from './App.vue';
import DebugTile from './components/DebugTile.vue';

import './registerServiceWorker';
import 'normalize.css';

import { isProduction } from './lib/helpers';

Vue.config.productionTip = false;

if (!isProduction) {
  Vue.component('DebugTile', DebugTile);
}

Vue.directive('focus', {
  inserted(el) {
    // TODO ugly hack for mobiles
    if (window && window.innerHeight < 600) return;

    Vue.nextTick(() => {
      el.focus();
    });
  },
});

new Vue({
  render: h => h(App),
}).$mount('#app');
